import { render, staticRenderFns } from "./CRAddressSelectorV2PrefillItem.vue?vue&type=template&id=1d688ee4&scoped=true"
import script from "./CRAddressSelectorV2PrefillItem.vue?vue&type=script&lang=js"
export * from "./CRAddressSelectorV2PrefillItem.vue?vue&type=script&lang=js"
import style0 from "./CRAddressSelectorV2PrefillItem.vue?vue&type=style&index=0&id=1d688ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d688ee4",
  null
  
)

export default component.exports